import React, {Component} from 'react'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import {reduxForm, Field, stopSubmit, startSubmit} from 'redux-form'

import BackOfficeNavigatorScreen from '../screens/BackOfficeNavigatorScreen'
import {Route, Switch, Redirect, NavLink} from 'react-router-dom'
import PassListContainer from './PassListContainer'
import BackOfficeUserScreen from '../screens/BackOfficeUserScreen'
import SostaOnlineApiService from '../services/SostaOnlineApiService'
import BackOfficeFiltersComponent from '../components/BackOfficeFiltersComponent'

const mapStateToProps = (state) => {
  return {
    state: state.users
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
  }
}

class BackOfficeUserTableContainer extends Component {
  constructor (props) {
    super(props)
    this.state = {
      users: [],
      pagination: {
        total: 0,
        limit: 100,
        offset: 0
      },
      filters: {}
    }

    this.onAllClick = this.onAllClick.bind(this)
    this.onWaitingClick = this.onWaitingClick.bind(this)
    this.onCreateUserClick = this.onCreateUserClick.bind(this)
    this.fetchUsers = this.fetchUsers.bind(this)
  }

  componentDidMount () {
    this.setState({loading: true})
    this.fetchUsers()
  }

  onCreateUserClick () {
    this.props.history.push('/backoffice/users/create')
  }

  fetchUsers (filterObj, limit, offset) {
    this.setState({loading: true})
    let string = ''
    for (let key in filterObj) {
      string = string + key + '=' + filterObj[key] + '&'
    }

    SostaOnlineApiService.fetchUsers(string, limit || 100, offset || 0).then((data) => {
      this.setState({
        users: data.data,
        pagination: data.pagination,
        loading: false
      })
    })
  }

  handleFilterChange (filter) {
    let newFilters = Object.assign({}, this.state.filters)
    if (filter.filterTerm) {
      newFilters[filter.column.key] = filter
    } else {
      delete newFilters[filter.column.key]
    }
    this.setState({ filters: newFilters })
  }

  onRowClick (rowIdx, row) {
    if (rowIdx <= -1 || !row) {
      return
    }

    this.props.history.push('/backoffice/users/' + row.id)
  }

  onClearFilters () {
    // all filters removed
    this.setState({filters: {} })
  }

  onAllClick () {
    this.props.history.push('/backoffice/users')
  }

  onWaitingClick () {
    this.props.history.push('/backoffice/users/waiting-list')
  }

  render () {
    return (
      <div>
        <div className="btn-group">
          <div className="btn-group" role="group">
            <button type="button" className="btn btn-add" onClick={this.onCreateUserClick}>
              <i className="glyphicon glyphicon-plus">{}</i> Utente
            </button>
            <NavLink exact className="btn ciaobtn" activeClassName="active" to={'/backoffice/users'}>Tutti</NavLink>
            <NavLink className="btn ciaobtn" activeClassName="active" to={'/backoffice/users/waiting-list'}>In Attesa ({this.props.thingsToDo.waitingMarks ? this.props.thingsToDo.waitingMarks : 0})</NavLink>
          </div>
        </div>
        <BackOfficeUserScreen
          loading={this.state.loading}
          fetchUsers={this.fetchUsers}
          onCreateUserClick={this.onCreateUserClick.bind(this)}
          users={this.state.users}
          rows={this.state.users}
          pagination={this.state.pagination}
          onRowClick={this.onRowClick.bind(this)}
          handleFilterChange={this.handleFilterChange.bind(this)}
          onClearFilters={this.onClearFilters.bind(this)} />
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(BackOfficeUserTableContainer)



// WEBPACK FOOTER //
// ./src/containers/BackOfficeUserTableContainer.js